import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FiMail } from "react-icons/fi";

const Footer = () => {
return ( <footer className="bg-[#1E1E1E] text-gray-300 pt-12">

  <div className="container mx-auto px-6">

    {/* TOP SECTION */}
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">

      {/* LOGO */}
      <div className="col-span-2 lg:col-span-1">
        <h2 className="text-white text-xl font-semibold mb-4">
         LappyShop
        </h2>
        <p className="text-sm text-gray-400">
          India's trusted refurbished electronics store.
        </p>
      </div>

      {/* ABOUT */}
      <div>
        <h3 className="text-white font-semibold mb-4">
          About Us
        </h3>
        <ul className="space-y-2 text-sm">
          <li>About LappyShop</li>
          <li>Refurbishing story</li>
          <li>Our story</li>
        </ul>
      </div>

      {/* PRODUCTS */}
      <div>
        <h3 className="text-white font-semibold mb-4">
          Our Products
        </h3>
        <ul className="space-y-2 text-sm">
          <li>Laptops</li>
          <li>Desktops</li>
          <li>Mini PC</li>
          <li>All in One</li>
          <li>Monitors</li>
        </ul>
      </div>

      {/* HELP */}
      <div>
        <h3 className="text-white font-semibold mb-4">
          Help
        </h3>
        <ul className="space-y-2 text-sm">
          <li>Contact Us</li>
          <li>Terms of Service</li>
          <li>Shipping Policy</li>
          <li>Return Policy</li>
          <li>Warranty Policy</li>
          <li>Privacy Policy</li>
        </ul>
      </div>

      {/* CONTACT */}
      <div>
        <h3 className="text-white font-semibold mb-4">
          Contact
        </h3>

        <p className="text-sm mb-2">
          +91-9871238339 (Sales)
        </p>

        <p className="text-sm mb-2">
          support@lappyshop.com
        </p>

        <p className="text-sm">
          9871238339(Bulk Enquiries)
        </p>

      </div>

    </div>

    {/* NEWSLETTER */}

    <div className="border-t border-gray-700 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">

      <div className="text-white font-medium">
        Sign up to our newsletter
      </div>

      <div className="flex items-center bg-[#2A2A2A] rounded-full px-4 py-2 w-full md:w-[350px]">

        <FiMail className="text-gray-400 mr-3" />

        <input
          type="email"
          placeholder="Enter email"
          className="bg-transparent outline-none text-sm flex-1"
        />

        <button className="bg-white text-black rounded-full w-8 h-8 flex items-center justify-center">
          →
        </button>

      </div>

      {/* SOCIAL */}

      <div className="flex gap-4 text-white text-lg">

        <FaFacebookF className="cursor-pointer hover:text-gray-400" />
        <FaTwitter className="cursor-pointer hover:text-gray-400" />
        <FaInstagram className="cursor-pointer hover:text-gray-400" />
        <FaLinkedinIn className="cursor-pointer hover:text-gray-400" />
        <FaYoutube className="cursor-pointer hover:text-gray-400" />

      </div>

    </div>

    {/* BOTTOM */}

    <div className="border-t border-gray-700 mt-8 py-6 text-sm text-gray-400 text-center">

      Copyright © 2026 LappyShop.

    </div>

  </div>

</footer>


);
};

export default Footer;
